import React from 'react'

import Button from 'components/common/Button'
import FormField from 'components/common/FormField'
import {
  Icon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from 'components/shared/Icon/Icon'
import { usePagination } from 'hooks/usePagination'

import styles from './Pagination.module.scss'

const getOptions = () => [
  { label: 6, value: 6 },
  { label: 10, value: 10 },
  { label: 25, value: 25 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
]

export const Pagination = ({
  currentPage,
  options = getOptions(),
  pageCount,
  perPage = 25,
  onSetPage,
  onSetPageSize,
}) => {
  const pages = React.useMemo(
    () => Array.from({ length: pageCount }, (_, i) => i + 1),
    [pageCount],
  )
  const hasPages = pages.length > 1

  const handlePageChange = page => {
    onSetPage(page - 1)
  }

  const { items } = usePagination({
    count: pageCount,
    page: currentPage,
    onChange: handlePageChange,
  })

  return (
    <div className={styles.pagination}>
      {hasPages && (
        <ul className={styles.buttons}>
          {items.map(({ page, type, disabled, selected, onClick }, index) => {
            const mapTypeToContent = {
              next: <Icon icon={ChevronRightIcon} size={16} />,
              page,
              previous: <Icon icon={ChevronLeftIcon} size={16} />,
            }
            const isStartEllipsisType = type === 'start-ellipsis'
            const isEndEllipsisType = type === 'end-ellipsis'

            if (isStartEllipsisType || isEndEllipsisType) {
              return (
                <li key={index}>
                  <span className={styles.placeholder}>...</span>
                </li>
              )
            }

            return (
              <li key={index}>
                <Button
                  className={styles.button}
                  onClick={onClick}
                  disabled={disabled}
                  outline={!selected}
                  primary={selected}
                >
                  {mapTypeToContent[type]}
                </Button>
              </li>
            )
          })}
        </ul>
      )}
      <FormField
        className={styles.field}
        menuPlacement="top"
        options={options}
        type="select"
        value={perPage}
        onChange={onSetPageSize}
        isSearchable={false}
      />
    </div>
  )
}
